module.exports = __webpack_public_path__ + "img/wsc.605aa415.png";